export const BASE_URL = "https://demo.andqxai.uz"